import { PropsWithChildren, ReactElement, useCallback, useState } from 'react';

import { DetailsContext } from './Details.context';
import { DetailsToggle } from './DetailsToggle/DetailsToggle';
import { DetailsContent } from './DetailsContent/DetailsContent';
import { DetailsState } from './Details.types';

export type DetailsProps = PropsWithChildren<{}>;

interface DetailsComponent {
  (props: DetailsProps): ReactElement;
  Toggle: typeof DetailsToggle;
  Content: typeof DetailsContent;
}

export const Details: DetailsComponent = ({ children }) => {
  const [{ isOpen }, setState] = useState<DetailsState>({
    isOpen: false,
  });

  const open = useCallback(() => {
    setState((prev) => ({ ...prev, isOpen: true }));
  }, []);

  const close = useCallback(() => {
    setState((prev) => ({ ...prev, isOpen: false }));
  }, []);

  return (
    <DetailsContext.Provider value={{ isOpen, open, close }}>
      {children}
    </DetailsContext.Provider>
  );
};

Details.Toggle = DetailsToggle;
Details.Content = DetailsContent;
